import React from 'react';



class Contact extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionOneC">
                        <svg> <rect></rect> </svg>

                        <div className="titleSectionOneC">
                            <h1>Contact</h1>

                        </div>
                        <form id="form" action="">
                            <label for="Name">
                                Name
                            </label>

                            <p>

                                <input type="text" name="name" id="name" />
                            </p>


                            <label>
                                Email
                            </label>
                            <p>

                                <input type="email" name="email" id="email" />
                            </p>
                            <label>
                                Mesagge
                            </label>
                            <p>

                                <textarea name="message" id="message" cols="30" rows="7"></textarea>
                            </p>
                            <p>
                                <button type="submit" className="animateButtonF">
                                    <p>Send </p>


                                </button>
                                <a href="mailto:james@devgrimaldo.com" id="javascript" rel="noreferrer"> </a>

                            </p>

                        </form>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Contact;